/**
 * 地图 DOM 标记上的图标(SVG 字符串)—— 司机端、管理端共用。
 *
 * ★ 原来是 emoji(🏪 🏭 🛵)。emoji 靠系统的彩色 emoji 字体,
 *   缺字体资源的环境(iOS 26.3 模拟器就是)里整张地图的标记都是「?」。
 *
 * ★ 标记是 maplibre 的 DOM 元素,不走 React,所以没法用 <Store /> 组件。
 *   线条拷自 lucide-react 1.55 的 store / factory / bike(ISC),
 *   和界面上其他地方的图标是同一个图形。描边用 currentColor,颜色跟着标记走。
 */
type Shape = ['path', string] | ['circle', string, string, string];

const svg = (shapes: Shape[]) =>
  '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" ' +
  'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
  shapes
    .map((s) => (s[0] === 'path' ? `<path d="${s[1]}"/>` : `<circle cx="${s[1]}" cy="${s[2]}" r="${s[3]}"/>`))
    .join('') +
  '</svg>';

export const STORE_SVG = svg([
  ['path', 'M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5'],
  [
    'path',
    'M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244',
  ],
  ['path', 'M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05'],
]);

export const FACTORY_SVG = svg([
  ['path', 'M12 16h.01'],
  ['path', 'M16 16h.01'],
  [
    'path',
    'M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z',
  ],
  ['path', 'M8 16h.01'],
]);

export const BIKE_SVG = svg([
  ['circle', '18.5', '17.5', '3.5'],
  ['circle', '5.5', '17.5', '3.5'],
  ['circle', '15', '5', '1'],
  ['path', 'M12 17.5V14l-3-3 4-3 2 3h2'],
]);
